import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, FormControl, Select, InputLabel, MenuItem, Tooltip, Fab, Icon } from '@material-ui/core';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from './RenderTextFieldRedux';


const validate = values => {
    const error  = {}
    /* if (!values.cedule) {
        error.cedule = "La cedula cedula es requerido"
    } */
    if (!values.code) {
        error.code = "Este campo es obligatorio"
    }
    return error
}
const BeneficiaryFindAccount = props => {
    const { handleSubmit, selectype} = props
    const [ data ] = React.useState( [{name: 'Identificación (Ruc, Cédula, Pasaporte)', value: 'cedule'}, {name: 'Número de cuenta', value: 'account'}])
    const [ labelText, setLabelText ] = React.useState( 'Cédula')
    return (
                <form  onSubmit={ handleSubmit }>
                    <Grid container spacing={3} justify="center" alignItems="center" >
                        <Grid item xs={12} md={6}>
                            <FormControl variant="outlined" style = {{width: '100%'}}>
                                <InputLabel id="demo-simple-select-outlined-label">{'Buscar por'}</InputLabel>
                                <Select
                                fullWidth
                                label={'Buscar por'}
                                labelId="demo-simple-select-label"
                                id="entity"
                                defaultValue={data[0]}
                                onChange={ (val) => {
                                    const { value } = val.target
                                    selectype(value)
                                    setLabelText(value.name)
                                } }
                                >
                                    {
                                        data.map(option => {
                                        return <MenuItem key={option.value} value={option}>{`${option.name}`}</MenuItem>
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={8} md={4}>
                            <Field
                                name="code"
                                id="code"
                                required
                                component={ RenderTextFieldRedux }
                                label={labelText}
                                type="text"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={4} md={2}>
                        <Tooltip title="Add" aria-label="add">
                                <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" type = "submit">
                                        <Icon>search</Icon>
                                </Fab>
                            {/* <Fab color="default" type="submit" disabled={submitting}>
                                <Avatar src = {process.env.PUBLIC_URL + '/icons/38.png'} variant="square" className={classes.imgLogo}/>
                            </Fab> */}
                        </Tooltip>
                        </Grid>
                    </Grid>
                </form>
    );
};

BeneficiaryFindAccount.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    valid: PropTypes.bool.isRequired
};
const FindAccountReduxForm = reduxForm(
    {
        form: 'FindAccountForm',
        validate
    }
)(BeneficiaryFindAccount)
export default setPropsAsInitial(FindAccountReduxForm)
// export default BeneficiaryFindAccount;